import LoginForm from "./LoginForm";
import { useIdleTimer } from "react-idle-timer";

export default function LoginContainer() {
  const onIdle = () => {
    // reload if user goes idle for 15 minutes
    window.location.href = window.location.origin;
  };

  useIdleTimer({
    onIdle,
    timeout: 900000
  });
  return <LoginForm />;
}
